import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'

import { CompLinearProgressWrapperCore } from '../core/linear-progress/wrapper'
import { CompLinearProgress } from './CompLinearProgress'

/**
 * CompLinearProgressWrapper
 */
const CompLinearProgressWrapper = () => {
  const compContext = useCompContext()
  const actionContext = useBuilderActionContextV2()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useCompBackgroundColor()

  return (
    <CompLinearProgressWrapperCore infos={{ ...compContext, activeLayer, currentParentBg }} action={actionContext}>
      {(props) => <CompLinearProgress {...props} />}
    </CompLinearProgressWrapperCore>
  )
}

export default CompLinearProgressWrapper
